<template>
	<div class="section container clients">
		<h2 class="section__heading clients__heading">{{ clientsHeading }}</h2>
		<div class="slider">
			<div class="slider__track" :style="`width: calc(15rem * ${logoCount})`">
				<div v-for="client in content.logosFirstRow" :key="client.name.en" class="slide">
					<nuxt-link v-if="client?.slug?.current"
										 :to="localePath(`/projects/${client?.slug?.current}`)"
											class="slide__link">
						<img :src="$urlFor(client.logo.asset.url, 350)"
								 :alt="client.name.en"
								 :height="client.logo.asset.metadata.dimensions.height"
								 :width="client.logo.asset.metadata.dimensions.width" />
					</nuxt-link>
					<img v-else
							 :src="$urlFor(client.logo.asset.url, 350)"
							 :alt="client.name.en"
							 :height="client.logo.asset.metadata.dimensions.height"
							 :width="client.logo.asset.metadata.dimensions.width" />
				</div>
			</div>
			<div class="slider__track" :style="`width: calc(15rem * ${logoCount})`">
				<div v-for="client in content.logosFirstRow" :key="client.name.en" class="slide">
					<nuxt-link v-if="client?.slug?.current"
										 :to="localePath(`/projects/${client?.slug?.current}`)"
											class="slide__link">
						<img :src="$urlFor(client.logo.asset.url, 350)"
								 :alt="client.name.en"
								 :height="client.logo.asset.metadata.dimensions.height"
								 :width="client.logo.asset.metadata.dimensions.width" />
					</nuxt-link>
					<img v-else
							 :src="$urlFor(client.logo.asset.url, 350)"
							 :alt="client.name.en"
							 :height="client.logo.asset.metadata.dimensions.height"
							 :width="client.logo.asset.metadata.dimensions.width" />
				</div>
			</div>
		</div>

		<div class="slider">
			<div class="slider__track slider__track--two" :style="`width: calc(15rem * ${logoCount})`">
				<div v-for="client2 in content.logosSecondRow" :key="client2.name.en" class="slide">
					<nuxt-link v-if="client2?.slug?.current"
										 :to="localePath(`/projects/${client2?.slug?.current}`)"
											class="slide__link">
						<img :src="$urlFor(client2.logo.asset.url, 350)"
								 :alt="client2.name.en"
								 :height="client2.logo.asset.metadata.dimensions.height"
								 :width="client2.logo.asset.metadata.dimensions.width" />
					</nuxt-link>
					<img v-else
							 :src="$urlFor(client2.logo.asset.url, 350)"
							 :alt="client2.name.en"
							 :height="client2.logo.asset.metadata.dimensions.height"
							 :width="client2.logo.asset.metadata.dimensions.width" />
				</div>
			</div>
			<div class="slider__track" :style="`width: calc(15rem * ${logoCount})`">
				<div v-for="client2 in content.logosSecondRow" :key="client2.name.en" class="slide">
					<nuxt-link v-if="client2?.slug?.current"
										 :to="localePath(`/projects/${client2?.slug?.current}`)"
											class="slide__link">
						<img :src="$urlFor(client2.logo.asset.url, 350)"
								 :alt="client2.name.en"
								 :height="client2.logo.asset.metadata.dimensions.height"
								 :width="client2.logo.asset.metadata.dimensions.width" />
					</nuxt-link>
					<img v-else
							 :src="$urlFor(client2.logo.asset.url, 350)"
							 :alt="client2.name.en"
							 :height="client2.logo.asset.metadata.dimensions.height"
							 :width="client2.logo.asset.metadata.dimensions.width" />
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { computed } from "vue";
import { useI18n, useLocalePath } from "#imports";
const { locale } = useI18n();
const localePath = useLocalePath();
const props = defineProps({
	content: Object
});
const logoCount = props.content.logos.length;
let clientsHeading;
if (props.content.title !== null) {
	clientsHeading = computed(() => locale.value === 'en' ? props.content.title.en : props.content.title.jp);
}
</script>

<style lang="scss" scoped>
@use '@/assets/sass/variables.scss' as v;
.clients {
	padding: 3rem 0;
	width: 100%;
	&__heading {
		margin: 0 0 0 1rem;
		@include v.respond-to('small') {
			margin: 0 0 0 3rem;
		}
	}
	.slider {
		display: flex;
		height: 7rem;
		margin: 1rem auto;
		overflow: hidden;
		position: relative;
		cursor: default;
		user-select: none;
		touch-action: none;
	}
	.slider .slider__track {
		animation: scroll-l 90s linear infinite;
		display: flex;
	}
	.slider__track--two {
		margin-left: 6rem;
	}
	.slider .slide {
		height: 7rem;
		width: 15rem;
		display: flex;
		justify-content: center;
		text-align: center;
		img {
			filter: grayscale(100);
			padding: 0 2.5rem;
			vertical-align: middle;
			margin: 0 auto;
			display: inline-block;
			max-height: 5rem;
			max-width: 100%;
			object-fit: contain;
			transition: 0.3s;

			&:hover {
				filter: grayscale(0);
				transition: 0.3s;
			}
		}
	}
	.slider .slide .slide__link {
		display: inline-block;
		overflow: visible;
		&:hover {
			background-color: transparent;
			cursor: pointer;
		}
	}

	@keyframes scroll-l {
		0% {
			transform: translateX(0);
		}
		100% {
			transform: translateX(-100%);
		}
	}
}
</style>
